import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { axiosWithToken, functionBaseUrl } from "../../../common/firebase";

const useDashboardUser = () => {
  const [user, setUser] = React.useState(null);
  const [isUserLoading, setIsLoading] = useState(true);
  const location = useLocation();

  const fetchUser = async () => {
    const getDashboardUser = async (userId) => {
      const res = await axiosWithToken(
        `${functionBaseUrl}/api/users/${userId}`,
        {
          method: "get",
        }
      );
      const subRes = !res?.data?.subscriptionType?.includes("free")
        ? await axiosWithToken(
            `${functionBaseUrl}/api/subscriptionByUserId/${userId}`,
            {
              method: "get",
            }
          )
        : { data: {} };
      return { ...res.data, sub: subRes.data.data, id: userId };
    };

    try {
      const queryParams = new URLSearchParams(location.search);
      const userId = queryParams.get("userId");

      const userData = await getDashboardUser(userId);

      setUser(userData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return { user, isUserLoading, fetchUser };
};

export default useDashboardUser;
